<template>
  <div class="management">
    <header class="header">
      <cl-page-back icon="page_back_white" @click="backFun">
        <span class="fs22">{{ routerInfo.year }}年龄段训练营</span>
      </cl-page-back>
    </header>
    <div class="table_box">
      <div class="table Table_Draggable">
        <el-table :data="tableData" height="100%" @row-click="handleTrClick">
          <template #empty>
            <cl-no-data />
          </template>
          <el-table-column :label="$t('camp.训练营名称')" prop="name" />
          <el-table-column :label="$t('report.时间')" width="260px">
            <template slot-scope="{ row }">
              <span class="DINM fs16"
                >{{ row.start_date }} - {{ row.end_date }}</span
              >
            </template>
          </el-table-column>
          <el-table-column :label="$t('camp.地点')" prop="pitch" />
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      routerInfo: {},
      tableData: [],
    };
  },

  methods: {
    backFun() {
      this.$router.go(-1);
    },
    async getData() {
      const { year, formPath } = this.routerInfo;
      const params = {
        year,
      };
      formPath === "home-woman"
        ? this.getWomanCampsData(params)
        : this.getCampsData(params);
    },
    // 所有训练营
    async getCampsData(params) {
      const { code, data } = await this.$server.getTriainingCamps(params);
      if (code === 200 && data) {
        this.tableData = data;
      }
    },
    async getWomanCampsData(params) {
      const { code, data } = await this.$server.getWomanTriainingCamps(params);
      if (code === 200 && data) {
        this.tableData = data;
      }
    },
    handleTrClick(row) {
      this.$router.push({
        path: "/training-camp/details",
        query: {
          id: row.id,
          tenantId: row.tenant_id,
        },
      });
    },
  },

  created() {
    this.routerInfo = this.$route.query;
    this.getData();
  },
};
</script>
<style lang="scss" scoped>
.management {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  .header {
    padding: 18px 24px;
    height: 115px;
    background: url("~@i/cfa/header_bg.png") center center no-repeat;
    background-size: 100% 100%;
    font-size: 22px;
    span {
      color: #fff;
    }
  }
  .table_box {
    position: absolute;
    top: 62px;
    flex: 1;
    width: 100%;
    height: calc(100% - 86px);
    padding: 0 24px;
    box-sizing: border-box;
    .table {
      height: 100%;
      width: 100%;
      padding: 10px 15px;
      border-radius: 4px;
      box-sizing: border-box;
    }
  }
}
::v-deep .el-table {
  color: #3a3a3a;
  .el-table__cell {
    padding: 16px 0;
  }
}
::v-deep .el-form-item__label {
  line-height: 17px;
  margin-bottom: 8px;
}
</style>
